module.exports = __webpack_public_path__ + "img/login_bg.ffa78897.png";